import { $tv } from 'react-tv-focusable';
import wetvKernel from '@tencent/wetv-kernel';
import { langIdToLangName, LGVChannelID } from './const';
import { getCookieAmend, setCookieAmend } from './cookie';
import defaultLang from './default-lang';
import { getTabConfig } from './tabExperiment';
import {
  getAppid,
  setGuid,
  AstroSetCookie,
  setPTInfo,
  setTVKPlatFormInfo,
  AstroSaveCookie,
  setVplatForm,
  setVideoAppid,
  setLangCode,
  getQueryVariable,
  filterVChannelId,
  getPlatKey,
  getInitPlayerKernel,
} from './util';
import { deviceDataReport } from './deviceDataReport';
const { configInstace, ageisReportor, user, langText } = wetvKernel;


/* ---------------通用------------- */
// 初始化键码值
function keyCodeInit() {
  const vChannelId = localStorage.getItem('v_channel_id');
  const compatibleKeycodes = vChannelId === '16610' ? 8 : null;
  if (typeof window.VK_ENTER === 'undefined') {
    window.VK_ENTER = 13;
  }
  if (typeof window.VK_LEFT === 'undefined') {
    window.VK_LEFT = 37;
  }
  if (typeof window.VK_RIGHT === 'undefined') {
    window.VK_RIGHT = 39;
  }
  if (typeof window.VK_UP === 'undefined') {
    window.VK_UP = 38;
  }
  if (typeof window.VK_DOWN === 'undefined') {
    window.VK_DOWN = 40;
  }
  if (typeof window.VK_BACK === 'undefined') {
    window.VK_BACK = compatibleKeycodes;
  }
  if (typeof window.VK_BACK_SPACE === 'undefined') {
    window.VK_BACKSPACE = 8;
  }
  if (typeof window.VK_PLAY === 'undefined') {
    window.VK_PLAY = 415;
  }
  if (typeof window.VK_PAUSE === 'undefined') {
    window.VK_PAUSE = 19;
  }
  if (typeof window.VK_PLAY_PAUSE === 'undefined') {
    window.VK_PLAY_PAUSE = 229;
  }
  if (typeof window.VK_STOP === 'undefined') {
    window.VK_STOP = 413;
  }
  if (typeof window.VK_REWIND === 'undefined') {
    window.VK_REWIND = 412;
  }
  if (typeof window.VK_FAST_FWD === 'undefined') {
    window.VK_FAST_FWD = 417;
  }
  if (typeof window.VK_RED === 'undefined') {
    window.VK_RED = 403;
  }
  if (typeof window.VK_BLUE === 'undefined') {
    window.VK_BLUE = 66;
  }
  if (typeof window.VK_GREEN === 'undefined') {
    window.VK_GREEN = 404;
  }
  if (typeof window.VK_YELLOW === 'undefined') {
    window.VK_YELLOW = 89;
  }
  if (typeof window.VK_PAGE_UP === 'undefined') {
    window.VK_PAGE_UP = 33;
  }
  if (typeof window.VK_PAGE_DOWN === 'undefined') {
    window.VK_PAGE_DOWN = 34;
  }
  if (typeof window.VK_INFO === 'undefined') {
    window.VK_INFO = 457;
  }
}

// 根据地址栏是否有debugger参数来判断是否是测试环境
// 目前这个在kernel包初始化时使用，并没有根据domain判断是否是测试环境
function isTestEnv() {
  return getQueryVariable('debugger');
}

// 将channelId信息保存在localstorage中
function setVChannelId() {
  const vChannelId = getQueryVariable('v_channel_id') || localStorage.getItem('v_channel_id');
  if (!vChannelId) return;
  const curVChannelId = filterVChannelId(vChannelId);
  localStorage.setItem('v_channel_id', curVChannelId);
  setCookieAmend('v_channel_id', curVChannelId);
  return curVChannelId;
}

// 设置国家码,如果本地有，则不设置，本地没有，则解析地址栏里的，有则设置，没有则不设置
function setCountryCode() {
  const countryCode = getQueryVariable('area_code');
  // 地址栏传国家码信息，将地址栏里传的国家码覆盖掉本地的
  if (!!countryCode) {
    setCookieAmend('country_code', countryCode);
  }
}

function setExtraReportMsg() {
  const utmSource = getQueryVariable('utm_source');
  const utmMedium = getQueryVariable('utm_medium');
  const utmCampaign = getQueryVariable('utm_campaign');
  window.sessionStorage.setItem('utm_source', utmSource || '');
  window.sessionStorage.setItem('utm_medium', utmMedium || '');
  window.sessionStorage.setItem('utm_campaign', utmCampaign || '');
}

const initLang = () => {
  try {
    const lang = setLangCode();
    user.lang = langIdToLangName[lang];
    const projectData = JSON.parse(localStorage.getItem('linux-tv') || '{}');
    if (!Object.keys(projectData.list || {}).length) {
      langText.setRevealLangText(defaultLang);
    }
  } catch (error) {
    console.log('initLang error: ', error);
  }
};

// kernel包初始化
export function kernelInit() {
  configInstace.cgiEnv = isTestEnv() ? 'test' : 'pro'; // CGI环境，默认正式环境。test：测试，pro：正式
  const { videoAppid, aegisAppid } = getAppid();
  configInstace.aegisMsgAppend = process.env.REACT_APP_SOFTWARE_INFO;
  configInstace.videoAppid = videoAppid;
  configInstace.aegisAppid = aegisAppid;
  configInstace.platform = '8';
  configInstace.proName = 'linux-tv'; // 项目名
  configInstace.langPrefix = 'linux_tv';
  configInstace.offlineLogCfg = {
    projectId: 'WETV_LINUX_FEEDBACK_LOG', // 第一步无极配置的项目名，用于建indexDB的database,
    index: ['vid', 'cid', 'vuid'], // 可选，你的索引, 命名不能使用 _ 连接
    // 可选，info 为你具体的索引值, 这个值最好在 new OfflineLog 的时候就指定, 不要去修改
    info: {
      vuid: user.uid || '',
    },
    // 可选，用于每次log的通用日志前缀设置
    prefix: () => {
      const now = new Date();
      const time = now.toISOString();
      const page = location.href || location.pathname || '';
      return `[${time}][${page}]`;
    },
  };
  // 进应用后设置aegis上报时对应的uin用户信息
  const uin = getCookieAmend('vuserid') || '';
  if (uin) {
    ageisReportor?.updateUin({
      vuserid: uin,
      vusession: getCookieAmend('vusession'),
    });
  };
}

// 隐私协议初始化
export function privacyStatusCheck() {
  if (window.location.hash === '#/parentGuidelines') {
    return;
  }
  if (!localStorage.getItem('parentGuidelines')) {
    const { pathname, hash, search } = window.location;
    sessionStorage.setItem('acceptPrivacyOriginPage', hash);
    window.location.replace(`${pathname}${search}#/parentGuidelines`);
  }
}

// 获取并设置三星电视信息
function setSamsung() {
  localStorage.setItem('deviceId', 'SAMSUNG');
}

// 获取并设置海信电视信息
function setHisenseInfo() {
  if (typeof window.Hisense_GetDeviceID === 'function') {
    const deviceId = window.Hisense_GetDeviceID();
    localStorage.setItem('deviceId', deviceId);
  } else {
    localStorage.setItem('deviceId', '');
  }
};

// 获取并设置LG电视信息
function setLGInfo() {
  const deviceInfo = JSON.parse(window.webOSSystem.deviceInfo);
  localStorage.setItem('deviceId', deviceInfo.panelType);
};

// 设置电视信息
function setTVInfo() {
  try {
    const vChannelId = localStorage.getItem('v_channel_id');
    if (vChannelId) {
      if (!!LGVChannelID.includes(vChannelId)) {
        // 获取LG电视信息
        setLGInfo();
      } else if (vChannelId === '16600' || vChannelId === '16599') {
        // 获取三星电视信息
        setSamsung();
      } else {
        // 获取海信电视信息
        setHisenseInfo();
      }
    } else {
      // 获取海信电视信息
      setHisenseInfo();
    }
  } catch (e) { }
};

// 默认设置，设置画面比例、清晰度、是否跳片头片尾、语言
function defaultSetting() {
  if (!localStorage.getItem('ratio')) {
    localStorage.setItem('ratio', '0');
  }
  if (!localStorage.getItem('definition')) {
    localStorage.setItem('definition', 'shd');
  }
  if (!localStorage.getItem('skipOver')) {
    localStorage.setItem('skipOver', '1');
  }
  if (!localStorage.getItem('id')) {
    localStorage.setItem('id', '1491988');
  }
  if (!localStorage.getItem('playerKernel')) {
    const playerKernel = getInitPlayerKernel();
    localStorage.setItem('playerKernel', playerKernel);
  }
  setTVInfo();
}

// 设置PT以及TVKPlatForm信息以及videoAppid、VplatForm、langCode
function setPTAndDeviceInfo() {
  const plat = getPlatKey();
  setPTInfo(plat);
  setTVKPlatFormInfo(plat);
  setVplatForm(plat);
  setVideoAppid(plat);
  // 需要设置langCode，还需要设置kernel多语言初始语言值
  initLang();
}
/* ---------------通用------------- */

/* ---------------LG------------- */
export function LGInit() {
  function getParams(e) {
    let launchParams = (e && e.detail)
      || (window.webOSDev && window.webOSDev.launchParams && window.webOSDev.launchParams())
      || (window.PalmSystem && window.PalmSystem.launchParams)
      || window.launchParams;
    if (!launchParams) return null;
    launchParams = typeof launchParams === 'string' ? JSON.parse(launchParams) : launchParams;
    const params = launchParams?.contentTarget;
    if (!params) return null;
    return params;
  }
  function handleRelaunch(e) {
    const params = getParams(e);
    // 目前只有LG才会有这个参数
    if (!!params) {
      window.location.href = `https://static.wetv.vip/tv/index.html${params}`; // params : ?prod_line=WETVLINUX&v_channel_id=16563&area_code=153548&utm_source=lge_16566&utm_medium=homepreview&utm_campaign=lge_16566#/particular/o0uyh6tfq4ifyxi/homepage
      setTimeout(() => { // 解决location.href跳转后，页面不刷新的问题，正确方式是使用 React Router 的 useNavigate 或 history.push 进行路由跳转
        location.reload();
      }, 500);
    }
  }
  document.addEventListener('webOSRelaunch', handleRelaunch);
}
/* ---------------LG------------- */

/* ---------------Astro------------- */
// 引入的 AstroSetCookie
// 引入的 AstroSaveCookie
/* ---------------Astro------------- */

/* ---------------聚焦插件------------- */
// 使用的focus依赖包的初始化配(键码值、默认寻找焦点方式、聚焦时滚动页面换焦点是否使用动画，滚动速度等)
// init的所有配置项可以在最后面的表格中查看
// https://www.npmjs.com/package/react-tv-focusable/v/1.0.0
// https://blog.csdn.net/sllailcp/article/details/109444532
export function focusPlugInit() {
  $tv.init({
    initDis: 40,
    KEYS: {
      KEY_LEFT: [37],
      KEY_UP: [38],
      KEY_RIGHT: [39],
      KEY_DOWN: [40],
      KEY_ENTER: [13, 65293], // ok键， 长按
      KEY_BACK: [640, 65367, 8, 27, 339, 90, 109, 283, 340], // 返回键
    }, // 自定义键值
    findFocusType: 1, // 即默认找最近焦点方式
    longPressTime: 800, // 长按响应时间（单位：毫秒），默认500ms
    distanceToCenter: true, // 是焦点始终在可是范围的中间部分， 默认false
    smoothTime: 0,
    spacingTime: 1000,
    // offsetDistance: 100,
    // scrollSpeedX: 200,
    scrollSpeed: 200,
  });
}
/* ---------------聚焦插件------------- */

/* ---------------wetvReportSDK------------- */
// https://git.woa.com/WeTV/WPC/common/sdk/wetv-report-sdk
export function wetvReportSDKInit(){
  const loadSdk = (url, name) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => {
      if (window[name]) {
        console.log('SDK loaded successfully', name);
        resolve(window[name]);
      } else {
        reject(new Error('SDK not found on window object'));
      }
    };
    script.onerror = () => {
      console.error('Failed to load SDK', name);
      reject(new Error('Failed to load SDK'));
    };
    document.head.appendChild(script);
  });

  const updatePageReport = () => {
    const pageNameTag = location.hash.match(/#\/([^/]+)\//)?.[1] || 'index';
    const pageName = `linux_${pageNameTag.toLocaleLowerCase()}`;
    const reportPageDom = document.getElementById('root');
    if (window.reportReady === 1 && window.wetvReportInstance) {
      window.wetvReportInstance.switchPage();
      window.wetvReportInstance
        .setPage(
          {
            pgid: `p_${pageName}`,
          },
          reportPageDom,
        )
        .observe(`p_${pageName}`);
    }
  };

  let hashChangeHandler = null;

  loadSdk('https://static.wetvinfo.com/libs/wetv-report-sdk/last/wetv-report-sdk.js', 'wetvReport')
    .then((WetvReport) => {
      try {
        const wetvReportInstance = new WetvReport({
          routerType: 'hash',
          warpSuccessFn: () => {
            updatePageReport();
            hashChangeHandler = () => updatePageReport();
            window.addEventListener('hashchange', hashChangeHandler);
            window.addEventListener('unload', () => {
              if (hashChangeHandler) {
                window.removeEventListener('hashchange', hashChangeHandler);
                hashChangeHandler = null;
              }
            });
          },
        });
        return wetvReportInstance;
      } catch (error) {
        console.error('Failed to initialize WetvReport:', error);
      }
    })
    .catch((error) => {
      console.error('loadSdk report error:', error);
    });
}

const tabExperimentInit = () => {
  getTabConfig('web_newplayer_version').then((expInfo) => {
    if (!expInfo) return;
    const { expParams } = expInfo;
    if (expParams) {
      const { offlineLog } = wetvKernel;
      const logger = offlineLog?.logger('fetcher');
      logger?.log(`[web_newplayer_version][expParams:${JSON.stringify(expParams)}]`);
      localStorage.setItem('tabConfig', JSON.stringify(expParams));
    }
  })
    .catch(() => {
      console.error('[debug]tabExperimentInit error');
    });
};

/* ---------------wetvReportSDK------------- */

export function projectInit() {
  // 设置渠道渠道Id(该方法中带修正逻辑)
  setVChannelId();
  // 隐私协议初始化
  privacyStatusCheck();
  // LG relaunch事件监听，处理跳转逻辑
  LGInit();
  // astro 之前保存在localStorage里的cookie设置到cookie里
  AstroSetCookie();
  // 设置国家码
  setCountryCode();
  // 设置上报信息
  setExtraReportMsg();
  // 设置guid,如果本地没有guid，生成guid并保存在本地
  setGuid();
  // 初始化kernel包
  kernelInit();
  // 键码值初始化(上下左右点击事件绑定对应键码值)
  keyCodeInit();
  // 设置PT以及TVKPlatForm信息
  setPTAndDeviceInfo();
  // astro将cookie中的内容保存在localStorage中
  AstroSaveCookie();
  // 落地页面定了之后处理是否接受了隐私协议,将落地页面保存在sessionStorage中，隐私协议点击接受后取出并跳回落地页面
  focusPlugInit();
  // 默认设置
  defaultSetting();
  wetvReportSDKInit();
  setTimeout(() => {
    // TAB实验能力
    tabExperimentInit();
    // 设备数据上报
    deviceDataReport();
  }, 500);
}
